import React from "react";
import moment from "moment-jalaali";
import Style from './TransactionList.module.css'
const TransactionList = ({ data }) => {
  return (
    <ul className={Style.ListHolder}>
      {data.map((item) => {
        return (
          <li key={item.id} className={Style.TransactionPart} style={item.card_number !== null?{border:"1px solid green"}:{border:"1px solid red"}}>
            <div>
              <p>عملیات</p>
              <p>تاریخ</p>
              <p>شبکه پرداخت</p>
              {item.card_number !== null ? <p>شماره کارت</p> : null}
            </div>
            <div>
              <p>
                {item.card_number !== null ? <span style={{color:'green',fontWeight:'600'}}>موفق</span> : <span style={{color:'red',fontWeight:'600'}}>ناموفق</span>}
              </p>
              <p  style={{direction:'ltr'}}>
                {" "}
                {moment
                  .unix(parseInt(item.date))
                  .format("jYYYY/jM/jD--hh:mm")}
              </p>
              <p>{item.payment_type}</p>
              {item.card_number !== null ? <p style={{direction:'ltr'}}>{item.card_number}</p> : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default TransactionList;
